import { render } from "./RecycleBin.vue?vue&type=template&id=a5d6804a&scoped=true"
import script from "./RecycleBin.vue?vue&type=script&lang=js"
export * from "./RecycleBin.vue?vue&type=script&lang=js"

import "./RecycleBin.vue?vue&type=style&index=0&id=a5d6804a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d6804a"]])

export default __exports__